// extracted by mini-css-extract-plugin
export default {"main_container":"AvailableProducts_main_container__dgIdF","productLoading":"AvailableProducts_productLoading__TnnP0","productError":"AvailableProducts_productError__zC1hx"};